'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - Class tab (select a row in Cabin view) - Grid
 */
var FlightClassGridTransformerFactory = function FlightClassGridTransformerFactory(DataTransformer, mergeScenarioDataService, bookingsIntakeTransformationService, momentService, userActionService, hepService, userService, flightLiveDataService, trendComputingService) {
  function FlightClassGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'class';
    this.targetType = ['class-flight-analysis', 'profile-chart-flight-cards'];
    this.priority = 1;
  }
  FlightClassGridTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightClassGridTransformer.constructor = FlightClassGridTransformer;
  FlightClassGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) > -1;
  };
  FlightClassGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightClassGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  function setLastRefreshTime(timeStamp) {
    if (timeStamp) {
      flightLiveDataService.setLastRefreshTime('class-flight-analysis', momentService.of(timeStamp, momentService.FIELD.EVENT_TIME_STAMP));
    }
  }
  function mergeLatestChanges(latestChanges, segClassLatestChanges) {
    if (latestChanges === null) {
      latestChanges = {};
    }
    _.forOwn(segClassLatestChanges, function (value, adjustmentName) {
      var newAdjustmentName;
      if (_.includes(adjustmentName, 'SegmentLimit')) {
        newAdjustmentName = adjustmentName;
      } else {
        newAdjustmentName = adjustmentName.replace(/^user/, 'userSegClass');
      }
      latestChanges[newAdjustmentName] = _.cloneDeep(value);
    });
    return latestChanges;
  }
  function addCustomClasses(newEntry, isFlightManagementTransformationEnabled) {
    if (isFlightManagementTransformationEnabled === true) {
      if (!newEntry.customClasses) {
        newEntry.customClasses = {};
      }
      newEntry.customClasses.segClassCurrentBookings = trendComputingService.getTrendClass(newEntry.segClassCurrentBookings, newEntry.segClassLastYearCurrentBookings);
      newEntry.customClasses.segClassCurrentRevenue = trendComputingService.getTrendClass(newEntry.segClassCurrentRevenue, newEntry.segClassLastYearCurrentRevenue);
      newEntry.customClasses.segClassExpectedBookings = trendComputingService.getTrendClass(newEntry.segClassExpectedBookings, newEntry.segClassLastYearFinalBookings);
      newEntry.customClasses.segClassExpectedRevenue = trendComputingService.getTrendClass(newEntry.segClassExpectedRevenue, newEntry.segClassLastYearFinalRevenue);
    }
  }
  FlightClassGridTransformer.prototype.transform = function (data, isFlightManagementTransformationEnabled) {
    setLastRefreshTime(_.get(data, 'domain.timeStamp'));
    var memorizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memorizedMomentOfDepartureTime = _.memoize(getMomentOfTime);
    var memorizedMomentOfArrivalTime = _.memoize(getMomentOfTime);
    var memorizedMomentOfEventDate = _.memoize(getMomentOfDate);
    var memoizedFormatUserActionList = _.memoize(userActionService.formatActionsList);
    var alertThreshold = hepService.getSimpleHepProperties().ALERT_THRESHOLD;
    var userSegmentTypes = {
      0: 'BOTH',
      1: 'LOCAL',
      2: 'CONNECT',
      get: function get(key) {
        return this[key] || this[0];
      }
    };
    var transformData = function transformData(legClassSegClassElements, isFlightManagementTransformationEnabled) {
      var result = [];
      for (var i = 0, length = legClassSegClassElements.length; i < length; i++) {
        var entry = legClassSegClassElements[i];
        var segmentDepartureDateMoment = memorizedMomentOfDepartureDate(entry.segmentDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var flightDepartureDateMoment = memorizedMomentOfDepartureDate(entry.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var momentDepartureTime = memorizedMomentOfDepartureTime(entry.departureTime, momentService.FIELD.DEPARTURE_TIME, memorizedMomentOfDepartureDate);
        var momentArrivalTime = memorizedMomentOfArrivalTime(entry.arrivalTime, momentService.FIELD.ARRIVAL_TIME, memorizedMomentOfDepartureDate);
        var eventTimeStamp = memorizedMomentOfEventDate(entry.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        var legDepartureDateMoment = memorizedMomentOfDepartureDate(entry.legDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var optGroupDateMoment = memorizedMomentOfDepartureDate(entry.optGroupDate, momentService.FIELD.DEPARTURE_DATE);
        var actions = memoizedFormatUserActionList(entry.userActionList);
        var action = actions[0];
        var newEntry = {
          // Technical fields
          entryKey: entry.carrier + entry.segment + entry.flightNumber + entry.flightDepartureDate + entry.segmentClass,
          flightId: entry.flightId,
          operatingCarrier: entry.operatingCarrier,
          scenarioName: entry.scenarioName,
          optGroupDate: optGroupDateMoment,
          referenceCurveFlightId: entry.referenceCurveFlightId,
          legId: entry.legId,
          leg: entry.leg,
          sequence: entry.sequence,
          legDepartureDateMoment: legDepartureDateMoment,
          legCabinId: entry.legCabinId,
          cabinIndex: entry.cabinIndex,
          legClass: entry.legClass,
          legClassId: entry.legClassId,
          segmentId: entry.segmentId,
          segmentClassId: entry.segmentClassId,
          lastProcessedDateMoment: eventTimeStamp,
          segClassRank: entry.segClassRank,
          segClassDisplaySeq: entry.segClassDisplaySeq,
          appliedRules: entry.appliedRules,
          numberOfAlertRulesApplied: entry.numberOfAlertRulesApplied,
          alertThresholdExceeded: entry.alertScore > alertThreshold,
          latestChanges: mergeLatestChanges(entry.latestChanges, entry.segClassLatestChanges),
          flightDepartureDateMoment: flightDepartureDateMoment,
          // Grid fields
          carrier: entry.carrier,
          flightNumber: entry.flightNumber,
          opsSuffix: entry.opsSuffix,
          segment: entry.segment,
          segmentDepartureDateMoment: segmentDepartureDateMoment,
          optGroupDateMoment: optGroupDateMoment,
          daysToDeparture: entry.daysToDeparture,
          departureTime: momentDepartureTime,
          arrivalTime: momentArrivalTime,
          equipment: entry.equipment,
          appliedRulesNumber: entry.appliedRules ? entry.appliedRules.length : 0,
          alerts: entry.alertScore,
          cabinCode: entry.cabinCode,
          segmentClass: entry.segmentClass,
          rank: !_.isNil(entry.rank) ? entry.rank : entry.segClassDisplaySeq,
          classDisplaySeq: entry.classDisplaySeq,
          segClassIsSetAside: entry.segClassIsSetAside,
          segClassWaitList: entry.segClassWaitList,
          // Fares
          segClassFare: entry.segClassFare,
          segClassMappedFare: entry.segClassMappedFare,
          segClassFlowFare: entry.segClassFlowFare,
          // Leg Cls Bookings
          legClassCurrentBookings: entry.legClassCurrentBookings,
          legClassLastYearCurrentBookings: entry.legClassLastYearCurrentBookings,
          legClassExpectedBookings: entry.legClassExpectedBookings,
          legClassLastYearFinalBookings: entry.legClassLastYearFinalBookings,
          // Seg Cls Bookings
          segClassCurrentBookings: entry.segClassCurrentBookings,
          segClassLastYearCurrentBookings: entry.segClassLastYearCurrentBookings,
          segClassExpectedBookings: entry.segClassExpectedBookings,
          segClassLastYearFinalBookings: entry.segClassLastYearFinalBookings,
          segClassCurrentGroupBookings: entry.segClassCurrentGroupBookings,
          segClassInvResHoldTotal: entry.segClassInvResHoldTotal,
          // Demand
          segClassRemainingDemandFC: entry.segClassRemainingDemandFC,
          segClassRemainingMappedDemandFC: entry.segClassRemainingMappedDemandFC,
          // Live Bookings
          liveIdvBkgs: entry.invResHoldIdv,
          liveGrpBkgs: entry.invResHoldGroup,
          // Leg Cls Allocations
          userAllocationType: _.get(entry, ['calculatedAdjustments', 'userAllocationType'], 'A'),
          userMinAllocation: entry.calculatedAdjustments ? entry.calculatedAdjustments.userMinAllocation : undefined,
          userMaxAllocation: entry.calculatedAdjustments ? entry.calculatedAdjustments.userMaxAllocation : undefined,
          // Leg Cls Prot
          protection: entry.protection,
          protectionCapped: entry.protectionCapped,
          segClassMinResSys: entry.segClassMinResSys,
          // Leg Cls Authorizations
          authorizationResSys: entry.authorizationResSys,
          authorizationModel: entry.authorizationModel,
          userMinAuthorization: entry.calculatedAdjustments ? entry.calculatedAdjustments.userHardOverrideType === 'AUTH' ? entry.calculatedAdjustments.userHardOverrideMinValue : null : null,
          userMaxAuthorization: entry.calculatedAdjustments ? entry.calculatedAdjustments.userHardOverrideType === 'AUTH' ? entry.calculatedAdjustments.userHardOverrideMaxValue : null : null,
          userAuthLink: entry.calculatedAdjustments ? entry.calculatedAdjustments.userLinkType === 'AUTH' ? entry.calculatedAdjustments.userLinkValue : null : null,
          userAuthorizationModel: entry.calculatedAdjustments ? entry.calculatedAdjustments.userAuthorizationModel : null,
          authorizationAfterRules: entry.authorizationAfterRules,
          // Segment Cls Authorizations
          segClassAuthorizationModel: entry.segClassAuthorizationModel,
          userSegClassMinAuthorization: entry.segClassCalculatedAdjustments.userHardOverrideType === 'AUTH' ? entry.segClassCalculatedAdjustments.userHardOverrideMinValue : null,
          userSegClassMaxAuthorization: entry.segClassCalculatedAdjustments.userHardOverrideType === 'AUTH' ? entry.segClassCalculatedAdjustments.userHardOverrideMaxValue : null,
          userSegClassAuthorizationModel: entry.segClassCalculatedAdjustments.userAuthorizationModel,
          segClassAuthorizationAfterRules: entry.segClassAuthorizationAfterRules,
          segClassNonNestedAuthEffective: entry.segClassNonNestedAuthEffective,
          // Leg Cls Availability
          seatsAvailResSys: entry.seatsAvailResSys,
          seatsAvailModel: entry.seatsAvailModel,
          userMinAvailability: entry.calculatedAdjustments ? entry.calculatedAdjustments.userHardOverrideType === 'AVAIL' ? entry.calculatedAdjustments.userHardOverrideMinValue : null : null,
          userMaxAvailability: entry.calculatedAdjustments ? entry.calculatedAdjustments.userHardOverrideType === 'AVAIL' ? entry.calculatedAdjustments.userHardOverrideMaxValue : null : null,
          userAvailLink: entry.calculatedAdjustments ? entry.calculatedAdjustments.userLinkType === 'AVAIL' ? entry.calculatedAdjustments.userLinkValue : null : null,
          userSeatsAvailModel: entry.calculatedAdjustments ? entry.calculatedAdjustments.userSeatsAvailModel : null,
          seatsAvailabilityAfterRules: entry.seatsAvailabilityAfterRules,
          // Seg Cls Availability
          segClassSeatsAvailResSys: entry.segClassSeatsAvailResSys,
          segClassSeatsAvailModel: entry.segClassSeatsAvailModel,
          userSegClassMinAvailability: entry.segClassCalculatedAdjustments.userHardOverrideType === 'AVAIL' ? entry.segClassCalculatedAdjustments.userHardOverrideMinValue : null,
          userSegClassMaxAvailability: entry.segClassCalculatedAdjustments.userHardOverrideType === 'AVAIL' ? entry.segClassCalculatedAdjustments.userHardOverrideMaxValue : null,
          userSegClassSeatsAvailModel: entry.segClassCalculatedAdjustments.userSeatsAvailModel,
          segClassSeatsAvailabilityAfterRules: entry.segClassSeatsAvailabilityAfterRules,
          liveSegClassAvail: entry.liveSegClassAvail,
          // Seg Limit
          segClassLimitType: userSegmentTypes.get(entry.segClassLimitType),
          segClassLimitResSys: entry.segClassLimitResSys === 999 ? '' : entry.segClassLimitResSys,
          userSegmentLimitType: userSegmentTypes.get(entry.segClassCalculatedAdjustments.userSegmentLimitType),
          userSegmentLimitResSys: entry.segClassCalculatedAdjustments.userSegmentLimitResSys === 999 ? '' : entry.segClassCalculatedAdjustments.userSegmentLimitResSys,
          eventTimeStamp: eventTimeStamp,
          // Leg Cls Revenue
          legClassCurrentRevenue: entry.legClassCurrentRevenue,
          legClassLastYearCurrentRevenue: entry.legClassLastYearCurrentRevenue,
          legClassExpectedRevenue: entry.legClassExpectedRevenue,
          legClassLastYearFinalRevenue: entry.legClassLastYearFinalRevenue,
          // Seg Cls Revenue
          segClassCurrentRevenue: entry.segClassCurrentRevenue,
          segClassLastYearCurrentRevenue: entry.segClassLastYearCurrentRevenue,
          segClassExpectedRevenue: entry.segClassExpectedRevenue,
          segClassLastYearFinalRevenue: entry.segClassLastYearFinalRevenue,
          flightTags: entry.flightTags ? entry.flightTags.toString() : undefined,
          actions: actions,
          actionType: _.get(action, 'type'),
          actionTime: _.get(action, 'time'),
          actionUser: _.get(action, 'user')
        };
        addCustomClasses(newEntry, isFlightManagementTransformationEnabled);
        bookingsIntakeTransformationService.calculateBookingsIntake(newEntry, entry, 'segClassBookingsIntake');
        result.push(newEntry);
      }
      return result;
    };
    var productionData = transformData(_.get(data, 'domain.resources') || _.get(data, 'domain.results') || [], isFlightManagementTransformationEnabled);
    var scenarioData = transformData(_.get(data, 'secondDomain.resources') || _.get(data, 'secondDomain.results') || [], isFlightManagementTransformationEnabled);
    return mergeScenarioDataService.merge(productionData, scenarioData);
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  function getMomentOfTime(date, field, memorizedMomentOfDate) {
    return memorizedMomentOfDate(date, field, 'HHmm');
  }
  return FlightClassGridTransformer;
};
FlightClassGridTransformerFactory.$inject = ['DataTransformerFactory', 'MergeScenarioDataService', 'BookingsIntakeTransformationService', 'MomentService', 'UserActionService', 'HepService', 'UserProcessingTransformationService', 'FlightLiveDataService', 'TrendComputingService'];
module.exports = FlightClassGridTransformerFactory;